import Vue from 'vue';
import Vuex from 'vuex';
// 用户信息
import user from './user';
// storage存储相关
import storage from './storage';
// 文件管理相关
import fileMng from './fileMng';
// 文件转换类型相关
import fileConvert from './fileConvert';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        storage,
        fileMng,
        fileConvert,
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js